/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import MainContainer from "../../../layout/MainContainer";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";

function PreviewOffer() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode");
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Preview Offer
            </h1>
          </div>
        </div>
        <div className="cards  view_page prvw_ofr">
          <h2>Image Upload</h2>
          <ul className="imgs_mn">
            <li>
              <figure>
                <img src="/static/images/preview1.png" alt="icon" />
              </figure>
            </li>
            <li>
              <figure>
                <img src="/static/images/preview2.png" alt="icon" />
              </figure>
            </li>
            <li>
              <figure>
                <img src="/static/images/preview3.png" alt="icon" />
              </figure>
            </li>
          </ul>
          <span className="tag">Dinning</span>
          <h2>Restaurant</h2>
          <div className="rstrnt_flx">
            <div className="rstrnt_lst">
              <p>
                Title
                <span>
                  <img src="/static/images/edit_icon.svg" />
                </span>
              </p>
              <h3>The Residence Tunis</h3>
            </div>
            <div className="rstrnt_lst">
              <p>
                Badge
                <span>
                  <img src="/static/images/edit_icon.svg" />
                </span>
              </p>
              <h3>Dinner & Games Night</h3>
            </div>
            <div className="rstrnt_lst">
              <p>
                Subtitle
                <span>
                  <img src="/static/images/edit_icon.svg" />
                </span>
              </p>
              <h3>The Residence Tunis</h3>
            </div>
            <div className="rstrnt_lst">
              <p>
                Groups
                <span>
                  <img src="/static/images/edit_icon.svg" />
                </span>
              </p>
              <h3>The Butterfly Effect</h3>
            </div>
            <div className="rstrnt_lst">
              <p>
                Tag
                <span>
                  <img src="/static/images/edit_icon.svg" />
                </span>
              </p>
              <h3>Breakfast</h3>
            </div>
            <div className="rstrnt_lst">
              <p>
                Offer Display Start Period
                <span>
                  <img src="/static/images/edit_icon.svg" />
                </span>
              </p>
              <h3>26-Jun-2025</h3>
            </div>
            <div className="rstrnt_lst">
              <p>
                Offer Display End Period
                <span>
                  <img src="/static/images/edit_icon.svg" />
                </span>
              </p>
              <h3>28-Jun-2025</h3>
            </div>
            <div className="rstrnt_lst">
              <p>
                Advance Booking Period
                <span>
                  <img src="/static/images/edit_icon.svg" />
                </span>
              </p>
              <h3>Weekly</h3>
            </div>
          </div>
          {mode?.toUpperCase() === "EXPERIENCE" ? (
            <>
              <div className="rstrnt_flx mt_30">
                <div className="rstrnt_lst">
                  <p>
                    End Date{" "}
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>12-06-2025</h3>
                </div>
                <div className="rstrnt_lst">
                  <p>
                    End Time{" "}
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>12:00 PM</h3>
                </div>
                <div className="rstrnt_lst">
                  <p>
                    Whats App Number{" "}
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>+91 98765246</h3>
                </div>
              </div>
            </>
          ) : mode?.toUpperCase() === "EVENTS" ? (
            <>
              <div className="rstrnt_flx mt_30">
                <div className="rstrnt_lst">
                  <p>
                    Event Date{" "}
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>12-06-2025</h3>
                </div>
                <div className="rstrnt_lst">
                  <p>
                    Event Time{" "}
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>12:00 PM</h3>
                </div>
              </div>
            </>
          ) : mode?.toUpperCase() === "OTHERS" ? (
            <>
              <div className="rstrnt_flx mt_30">
                <div className="rstrnt_lst">
                  <p>
                    End Date{" "}
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>12-06-2025</h3>
                </div>
                <div className="rstrnt_lst">
                  <p>
                    End Time{" "}
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>12:00 PM</h3>
                </div>
                <div className="rstrnt_lst">
                  <p>
                    Advance Booking Period
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>Weekly</h3>
                </div>
              </div>
            </>
          ) : null}

          <div className="btrfly_eft_mn">
            <div className="btrfly_eft_lft">
              <div className="btrfly_eft control_group w_50">
                <label>Butterfly Effect</label>
                <IosSwitchMain />
              </div>
              <div className="effts_dscrptn">
                <p>
                  Description
                  <span>
                    <img src="/static/images/edit_icon.svg" />
                  </span>
                </p>
                <h3>
                  Savor the Flavors of Sucre: Where Culinary Excellence Meets
                  Creativity
                </h3>
              </div>
              <div className="cncltn_plcy">
                <h2>Cancellation Policy</h2>
                <div className="effts_dscrptn">
                  <p>
                    Cancellation Policy
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>300 AED</h3>
                </div>
                <div className="effts_dscrptn">
                  <p>
                    Cancellation Hours
                    <span>
                      <img src="/static/images/edit_icon.svg" />
                    </span>
                  </p>
                  <h3>4 Hours</h3>
                </div>
              </div>
            </div>
            <div className="btrfly_eft_ryt">
              <figure>
                <img src="/static/images/dinning.png" alt="" />
              </figure>
              <div className="btrfly_eft_rytcnt">
                <span>Dinning</span>
                <h3>The Residence Tunis</h3>
                <p>
                  Savor the Flavors of Sucre: Where Culinary Excellence Meets
                  Creativity
                </p>
              </div>
            </div>
          </div>
          <div className="control_group w_100 prfrnc">
            <label>
              Seating preferences{" "}
              <img src="/static/images/edit_icon.svg" alt="icon" />{" "}
            </label>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Indoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel control={<Checkbox />} label="Indoor Seating" />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
            </FormGroup>
          </div>
          <div className="btn_flex flx_end">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-offer/preview-offer-detail")}
            >
              Publish
            </Button>
          </div>
        </div>
      </MainContainer>
    </>
  );
}

export default PreviewOffer;
